<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import "./assets/styles/main.scss";
export default {
  name: "App",

  data: () => ({
    //
  }),
  methods: {},
};
</script>
